import DateUtil from "@/util/DateUtil.js";

const list = {
  components() {
    return [
      {
        component: "search-year",
        label: "",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-month",
        label: "월",
        value: "month",
        query: { y_m: "month" },
        options: {
          default: "",
          lastLabel: true,
          useAll: true,
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["실시구분", "사업장명", "대상년도", "작성일", "제개정일", "첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 분기
    const year = search.year;
    const month = search.month;

    if (month) {
      const targetDay = new Date(`${year}-${month}-01`);
      conditions.push({ key: "body.monthDate", operator: ">=", value: targetDay.format("yyyy-MM-dd") });
      conditions.push({ key: "body.monthDate", operator: "<", value: targetDay.addMonths(1).format("yyyy-MM-dd") });
    } else {
      conditions.push({ key: "body.monthDate", operator: ">=", value: new Date(`${year}-01-01`).format("yyyy-MM-dd") });
      conditions.push({ key: "body.monthDate", operator: "<", value: new Date(`${year + 1}-01-01`).format("yyyy-MM-dd") });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getHead: () => {
    return [
      {
        name: "실시구분",
        key: "header.monthDate",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "심의대상(건)",
        key: "body.subInfo.심의대상",
      },
      {
        name: "의결(건)",
        key: "body.subInfo.의견",
      },
      {
        name: "조건부의결(건)",
        key: "body.subInfo.조건부의결",
      },
      {
        name: "기각(건)",
        key: "body.subInfo.기각",
      },
      {
        name: "재검토(건)",
        key: "body.subInfo.재검토",
      },
      {
        name: "종사자 의견",
        key: "body.subInfo.종사자의견",
        style: { maxWidth: "400px" },
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
      case 0:
        return `${postContent.header.month}월`; // 실시구분
      case 1:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 2:
        return func.getContent(value).subInfo.심의대상; // 심의대상(건)
      case 3:
        return func.getContent(value).subInfo.의견; // 의견(건)
      case 4:
        return func.getContent(value).subInfo.조건부의결; // 조건부의결(건)
      case 5:
        return func.getContent(value).subInfo.기각; // 기각(건)
      case 6:
        return func.getContent(value).subInfo.재검토; // 재검토(건)
      case 7:
        return func.getContent(value).subInfo.종사자의견; // 종사자 의견
      case 8:
        return func.getContent(value).stdInfo.section; // 부서명
      case 9:
        return func.getCreatedDate(value.created_at); // 작성일
      case 10:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
